/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SlimUser } from './SlimUser';
export type PublicAuditLog = {
  readonly id?: number;
  user: SlimUser;
  /**
   * Intended when using audited manage commands
   */
  reason?: string | null;
  /**
   * CREATE, UPDATE or DELETE, to be written by DB trigger
   */
  mutation_type: PublicAuditLog.mutation_type;
  created_at: string;
  /**
   * Contains the new information for CREATE and UPDATE mutations (includes soft deletions)
   */
  changed_payload: any;
  readonly model?: string;
  /**
   * Can be null for Attio related actions, or non-valuation events (e.g. sent email)
   */
  record_id?: number | null;
  readonly domain_area?: PublicAuditLog.domain_area;
  root_entity_id?: number | null;
  root_entity_type?: PublicAuditLog.root_entity_type | null;
  readonly company_name?: string;
};
export namespace PublicAuditLog {
  /**
   * CREATE, UPDATE or DELETE, to be written by DB trigger
   */
  export enum mutation_type {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
  }
  export enum domain_area {
    ALLOCATIONS = 'allocations',
    VALUATIONS = 'valuations',
    FINANCIALS = 'financials',
    DOCUMENTS = 'documents',
    COMPANIES = 'companies',
    CAP_TABLE = 'cap_table',
    FULFILLMENTS = 'fulfillments',
    FUNDS = 'funds',
    FIRMS = 'firms',
    FUND_OWNERSHIP = 'fund_ownership',
  }
  export enum root_entity_type {
    ALLOCATION = 'allocation',
    VALUATION = 'valuation',
    FINANCIAL_STATEMENT = 'financial_statement',
    MEASUREMENT_DATE_DOCUMENTS = 'measurement_date_documents',
    COMPANY = 'company',
    CAP_TABLE = 'cap_table',
    FUND_OWNERSHIP = 'fund_ownership',
    FULFILLMENT = 'fulfillment',
    FUND = 'fund',
  }
}
